export const ImageToImageModels = [
  {
    fn_index: 11,
    trigger_id: 15,
    label: "Art style transfer",
    name: "art_style_transfer",
    galleries: [
      {
        label: "Image",
        name: "image",
        galleryLabel: "Image examples",
        paths: [
          `/file=/root/img2img/tmp/1133af6a787b5035c77c3487f28d1a1e3de3de5e/belfry-cropped.jpg`,
          `/file=/root/img2img/tmp/eef33e99bb3e850d1f84e74243a59221c81ab818/puppy-cropped.jpg`,
          `/file=/root/img2img/tmp/b0d64b91221fff2d8774d7541f34965af2043aec/statue-of-liberty.jpg`,
          `/file=/root/img2img/tmp/98e8c9fee517c9c3728337f64e81b31e99cef763/m_content.png`,
          `/file=/root/img2img/tmp/b8a04e4c9c28bef8484e42e687beceaa7d7ffa84/bridge.jpg`,
          `/file=/root/img2img/tmp/3e6fa39dc813c11a98dcfa8ccac395c60c2e2dea/streets.jpg`,
        ]
      },
      {
        label: "Art style image",
        name: "art_style_image",
        galleryLabel: "Art style examples",
        paths: [
          `/file=/root/img2img/tmp/3aad5fd42f361d8a69ab783a759e459b1781e49e/tom_and_jerry.jpg`,
          `/file=/root/img2img/tmp/f14e4a311450e5ba0b9402adde59eb3c8b61400e/m_style.png`,
          `/file=/root/img2img/tmp/4b15fe5fcf1b7a67de7c5d2dee9ed17fad1d0403/starry_night.jpg`,
          `/file=/root/img2img/tmp/d2b40fc841fca6ca937c3cb81e5628288e84af60/style23.jpg`,
          `/file=/root/img2img/tmp/a8cfecdeb94bdd2e865edaad86c51fdefbe86229/style4.jpg`,
          `/file=/root/img2img/tmp/499ee94133c32568901b22cb1dd2f4167837704d/the_scream.jpg`,
        ]
      }
    ]
  },
  {
    fn_index: 12,
    trigger_id: 82,
    label: "Background removal",
    name: "background_removal",
    galleries: [
      {
        label: "Image",
        name: "background",
        galleryLabel: null,
        paths: [
          `/file=/root/img2img/tmp/5de4d9d59a4581c1b23f96144ba93fe92ed2fdea/Dubai_Marina_Skyline.jpg`,
          `/file=/root/img2img/tmp/d3eca8c94d61fee2df5636121dab5310500c7070/hamburger.jpg`,
          `/file=/root/img2img/tmp/96a0e5038e812ba94dcfaeaf20969a28d3d65d20/spongebob.webp`,
          `/file=/root/img2img/tmp/bbecbe259ac40f4be2c355e3c05bf84b4bde7251/chipmunk.jpg`,
          `/file=/root/img2img/tmp/5a493cd2ae7220ada37c5be29076250ed9fe7f9b/McLaren.jpeg`,
        ]
      }
    ]
  },
  {
    instructions: "Upload an image and fill in the area you want to erase.",
    fn_index: 13,
    trigger_id: 25,
    label: "Object erasing",
    name: "object_erasing",
    drawing_enabled: true,
    galleries: [
      {
        label: "Image",
        name: "background",
        galleryLabel: null,
        isLocal: true,
        paths: [
          `/images/showcase/image-to-image/baloon.jpg`,
          `/images/showcase/image-to-image/bird.jpg`,
          `/images/showcase/image-to-image/beach.jpg`,
          `/images/showcase/image-to-image/office.png`,
          `/images/showcase/image-to-image/snow_mountain.jpg`,
        ]
      },
    ]
  },
  {
    instructions: "Upload an image, fill the area you want painted, and describe your request using the prompts",
    fn_index: 8,
    trigger_id: 72,
    label: "In painting",
    name: "in_painting",
    drawing_enabled: true,
    galleries: [
      {
        label: "Image",
        name: "background",
        galleryLabel: null,
        isLocal: true,
        paths: [
          `/images/showcase/image-to-image/baloon.jpg`,
          `/images/showcase/image-to-image/bird.jpg`,
          `/images/showcase/image-to-image/beach.jpg`,
          `/images/showcase/image-to-image/office.png`,
          `/images/showcase/image-to-image/snow_mountain.jpg`,
        ]
      },
    ],
    prompts: [
      {
        name: "prompt",
        label: "Prompt"
      }, {
        name: "negative_prompt",
        label: "Negative prompt"
      }
    ],
    rangeInputs: [
      {
        name: "seed",
        label: "Seed",
        min: 0,
        max: 2147483647,
        step: 1,
        default: 300000000,
        long: true,
        desc: "The seed to use for the random number generator. Changing this will produce different results.",
      }
    ]
  },
  {
    fn_index: 14,
    trigger_id: 92,
    label: "Image upscaling",
    name: "image_upscaling",
    galleries: [
      {
        label: "Image",
        name: "image_to_upscale",
        galleryLabel: null,
        paths: [
          `/file=/root/img2img/tmp/53985aa890ac74a9a9c156b0956f1b7948019424/flower.jpg`,
          `/file=/root/img2img/tmp/20ba11a2514c70ee8acf03af87b1967342db1678/cat.png`,
          `/file=/root/img2img/tmp/bc1da0831a870c562bd7bd11f46e2c5f76add769/grandpa.png`,
          `/file=/root/img2img/tmp/5590b0af3cfe6c6bf67172c39554d6664f6242b1/camel.jpg`,
        ]
      }
    ]
  },
  {
    label: "Grounding dino",
    name: "grounding_dino",
    galleries: [
      {
        label: "Image",
        name: "input_img",
        galleryLabel: null,
        paths: [
          `/file=/root/img2img/tmp/5de4d9d59a4581c1b23f96144ba93fe92ed2fdea/Dubai_Marina_Skyline.jpg`,
          `/file=/root/img2img/tmp/d3eca8c94d61fee2df5636121dab5310500c7070/hamburger.jpg`,
          `/file=/root/img2img/tmp/96a0e5038e812ba94dcfaeaf20969a28d3d65d20/spongebob.webp`,
          `/file=/root/img2img/tmp/bbecbe259ac40f4be2c355e3c05bf84b4bde7251/chipmunk.jpg`,
          `/file=/root/img2img/tmp/5a493cd2ae7220ada37c5be29076250ed9fe7f9b/McLaren.jpeg`,
        ]
      },
    ],
    prompts: [
      {
        name: "detection_prompt",
        label: "Detection Prompt"
      }
    ],
    rangeInputs: [
      {
        name: "box_threshold",
        label: "Box Threshold",
        min: 0,
        max: 1,
        step: 0.01,
        default: 0.25,
        desc: "Box Threshold description",
        className: 'mid'
      },
      {
        name: "text_threshold",
        label: "Text Threshold",
        min: 0,
        max: 1,
        step: 0.01,
        default: 0.25,
        desc: "Text Threshold description",
        className: 'mid'
      }
    ]
  },
  {
    label: "InstantID",
    name: "instant_id",
    galleries: [
      {
        label: "Face Image",
        name: "face_img",
        galleryLabel: null,
        paths: [
          `/file=/root/img2img/tmp/1133af6a787b5035c77c3487f28d1a1e3de3de5e/belfry-cropped.jpg`,
          `/file=/root/img2img/tmp/eef33e99bb3e850d1f84e74243a59221c81ab818/puppy-cropped.jpg`,
          `/file=/root/img2img/tmp/b0d64b91221fff2d8774d7541f34965af2043aec/statue-of-liberty.jpg`,
          `/file=/root/img2img/tmp/98e8c9fee517c9c3728337f64e81b31e99cef763/m_content.png`,
          `/file=/root/img2img/tmp/b8a04e4c9c28bef8484e42e687beceaa7d7ffa84/bridge.jpg`,
          `/file=/root/img2img/tmp/3e6fa39dc813c11a98dcfa8ccac395c60c2e2dea/streets.jpg`,
        ]
      },
      {
        label: "Pose Image(*optional)",
        name: "pose_img",
        galleryLabel: null,
      },
    ],
    prompts: [
      {
        name: "prompt",
        label: "Prompt"
      },
      {
        name: "negative_prompt",
        label: "Negative Prompt"
      }
    ],
    rangeInputs: [
      {
        label: "Number Steps",
        name: "num_steps",
        desc: "Number of inference steps for the diffusion process. Higher values generally produce more detailed outputs but take longer.",
        min: 20,
        max: 100,
        step: 1,
        default: 30,
        className: 'mid'
      },
      {
        label: "Guidance Scale",
        name: "guidance_scale",
        desc: "Controls how strongly the model follows the prompt. Higher = more adherence to the prompt (but may reduce realism or identity preservation).",
        min: 0.1,
        max: 10,
        step: 0.1,
        default: 5,
        className: 'mid'
      },
      {
        label: "Adaptor Strength Ratio",
        name: "adaptor_strength_ratio",
        desc: "Adjusts the balance between identity features and prompt/styling. Higher = more identity focus, lower = more creativity/stylization.",
        min: 0,
        max: 1.5,
        step: 0.1,
        default: 0.8,
        className: 'mid'
      },
      {
        label: "Identity Strength Ratio",
        name: "identity_strength_ratio",
        desc: "Controls how strongly the generated image adheres to the identity in face image. Higher = more resemblance.",
        min: 0,
        max: 1.5,
        step: 0.1,
        default: 0.8,
        className: 'mid'
      }
    ],
    choiceInputs: [
      {
        label: "Style Name",
        name: "style_name",
        desc: "",
        default: "(No style)",
        desc: 'Predefined style to apply to the output image. Options include "Neon", "Film Noir", "Watercolor", etc. Use "(No style)" to keep the image realistic or unstyled.',
        choices: {
          "Mars": "Mars",
          "Neon": "Neon",
          "Snow": "Snow",
          "Jungle": "Jungle",
          "Line art": "Line art",
          "Film Noir": "Film Noir",
          "(No style)": "(No style)",
          "Watercolor": "Watercolor",
          "Vibrant Color": "Vibrant Color"
        },
        long: true
      },
      {
        label: "Enable Lcm",
        name: "enable_lcm",
        desc: "Enables Latent Consistency Model (LCM) for faster inference or specific model behavior.",
        default: false,
        choices: {
          'true': 'true',
          'false': 'false'
        },
        isBoolean: true
      },
      {
        label: "Enhance Face Region",
        name: "enhance_face_region",
        desc: "If true, applies additional enhancement or super-resolution to the face area, improving clarity and details.",
        default: false,
        choices: {
          'true': 'true',
          'false': 'false'
        },
        isBoolean: true
      },
    ],
    switchInputs: [
      {
        label: "Seed",
        checkboxLabel: "Enable Random Seed",
        name: "seed",
        desc: "Random seed for deterministic results. Using the same seed with the same inputs will yield the same output",
        min: 0,
        max: 2147483647,
        step: 1,
        default: 42,
        long: true,
        className: 'mid'
      },
    ]
  },
  {
    label: "ESRGAN",
    name: "esrgan",
    galleries: [
      {
        label: "Image",
        name: "input_img",
        galleryLabel: null,
        paths: [
          `/file=/root/img2img/tmp/53985aa890ac74a9a9c156b0956f1b7948019424/flower.jpg`,
          `/file=/root/img2img/tmp/20ba11a2514c70ee8acf03af87b1967342db1678/cat.png`,
          `/file=/root/img2img/tmp/bc1da0831a870c562bd7bd11f46e2c5f76add769/grandpa.png`,
          `/file=/root/img2img/tmp/5590b0af3cfe6c6bf67172c39554d6664f6242b1/camel.jpg`,
        ]
      }
    ]
  },
  {
    label: "Blip",
    name: "blip",
    galleries: [
      {
        label: "Image",
        name: "input_img",
        galleryLabel: null,
        paths: [
          `/file=/root/img2img/tmp/53985aa890ac74a9a9c156b0956f1b7948019424/flower.jpg`,
          `/file=/root/img2img/tmp/20ba11a2514c70ee8acf03af87b1967342db1678/cat.png`,
          `/file=/root/img2img/tmp/bc1da0831a870c562bd7bd11f46e2c5f76add769/grandpa.png`,
          `/file=/root/img2img/tmp/5590b0af3cfe6c6bf67172c39554d6664f6242b1/camel.jpg`,
        ]
      }
    ]
  }
]

export const HostedImgToImgModelNames = [{ name: 'Art style transfer' }, { name: 'Background removal' },
{ name: 'Image upscaling' }]